//
export default [
    {
        text: "#",
        value: "id",
    },
    {
        text: "nombre",
        value: "name",
    },
    {
        text: "Tasa trabajadores dependientes",
        value: "dependent_rate",
        align: "right",
        format: "percentage",
    },
    {
        text: "Tasa trabajadores independientes",
        value: "independent_rate",
        align: "right",
        format: "percentage",
    },
]
